import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "place"
}
const _hoisted_5 = {
  key: 0,
  class: "info"
}
const _hoisted_6 = { class: "d-flex justify-content-between gap-xs" }
const _hoisted_7 = { class: "reward" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 1,
  class: "info"
}
const _hoisted_10 = { class: "name" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 2,
  class: "balance-wrapper"
}
const _hoisted_13 = { class: "balance" }
const _hoisted_14 = { class: "amount hidden" }
const _hoisted_15 = { class: "amount" }

import {useStore} from "vuex";
import {numberFormatter} from "@/service/NumberFormatter";
import {computed, onMounted, ref, watch} from "vue";
import {Currency} from "@/models/enum/Currency";
import {useRoute} from "vue-router";
import {reactive} from "@vue/reactivity";
import TournamentSidebar from "@/components/TournamentSidebar.vue";
import UserDTO from "@/models/UserDTO";
import TournamentDTO from "@/models/TournamentDTO";
import {tournamentName} from "@/models/enum/TournamentType";
import {startInLabelText, timeLeftLabelText} from "@/service/DateHelper";
import {TournamentStatus} from "@/models/enum/TournamentStatus";

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const route = useRoute()
const store = useStore()

const state = reactive({
  isTournamentsVisible: false as boolean
})

const balance = computed(() => {
  return store.getters.getBalance(Currency.GOLD_COIN)
})

const displayValue = ref(balance.value);

const animateValue = (from: number, to: number, duration = 800) => {
  const start = performance.now();

  function frame(now: number) {
    const progress = Math.min((now - start) / duration, 1);
    const value = from + (to - from) * progress;

    displayValue.value = Math.floor(value).toString()
    if (progress < 1) {
      requestAnimationFrame(frame);
    }
  }
  requestAnimationFrame(frame);
}

watch(() => balance.value, async (newValue, oldValue) => {
  const oldBalance = Number.parseFloat(oldValue);
  const newBalance = Number.parseFloat(newValue);
  if (newBalance > oldBalance) {
    animateValue(oldBalance, newBalance);
  } else {
    displayValue.value = newBalance.toString()
  }
})

const headerTournament = computed((): TournamentDTO => {
  const user: UserDTO|null = store.getters.getUser

  const tournament = store.getters.liveTournaments.find((item: TournamentDTO) => item.id === user?.currentTournamentParticipant?.tournamentId)
  if (!tournament) {
    return store.getters.liveTournaments[0]
  }

  return tournament;
})

const durationLabel = computed(() => {
  return headerTournament.value.status === TournamentStatus.ACTIVE
    ? timeLeftLabelText(headerTournament.value.endAt)
    : startInLabelText(headerTournament.value.startAt)
})

const headerTournamentType = computed(() => {
  if (!headerTournament.value) {
    return null;
  }

  return tournamentName(headerTournament.value?.type)
})

const isGameWrapperRoute = computed(() => {
  return route.name === 'gameWrapper';
})

const isTournamentSidebarVisible = computed(() => {
  return isGameWrapperRoute.value && state.isTournamentsVisible
})

const toggleTournaments = () => {
  state.isTournamentsVisible = !state.isTournamentsVisible
}


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["top-menu", [_unref(store).getters.isLoggedIn ? 'login' : '']])
    }, [
      _createElementVNode("header", _hoisted_1, [
        (isGameWrapperRoute.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "header-tournament",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (toggleTournaments()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: `/img/tournaments/icons/${headerTournamentType.value}.png`
                }, null, 8, _hoisted_3),
                (_unref(store).getters.getUser?.currentTournamentParticipant)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(_unref(store).getters.getUser?.currentTournamentParticipant.place), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_unref(store).getters.getUser?.currentTournamentParticipant)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[1] || (_cache[1] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(numberFormatter).formatNumber(_unref(store).getters.getUser?.currentTournamentParticipant.prize)), 1)
                      ])
                    ]),
                    _createElementVNode("span", {
                      class: "duration",
                      innerHTML: durationLabel.value
                    }, null, 8, _hoisted_8)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(`tournament_short_names.${headerTournamentType.value}`)), 1),
                    _createElementVNode("span", {
                      class: "duration",
                      innerHTML: durationLabel.value
                    }, null, 8, _hoisted_11)
                  ]))
            ]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              to: {name:'home'},
              style: {"align-self":"center"}
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("img", {
                  alt: "logo",
                  src: "/img/logo.png",
                  style: {"height":"30px"}
                }, null, -1)
              ])),
              _: 1,
              __: [2]
            })),
        (_unref(store).getters.isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[3] || (_cache[3] = _createElementVNode("img", { src: "/img/coins/gold_coin.svg" }, null, -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_unref(numberFormatter).formatNumber(displayValue.value)?.replaceAll(/\d/g, '0')), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(numberFormatter).formatNumber(displayValue.value)), 1)
              ]),
              _createVNode(_component_router_link, {
                to: {name:'store'},
                class: "btn btn-primary text-capitalize-first"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('buy')), 1)
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: {name:'login'},
              class: "btn btn-primary text-capitalize-first"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('login')), 1)
              ]),
              _: 1
            }))
      ])
    ], 2),
    (isTournamentSidebarVisible.value)
      ? (_openBlock(), _createBlock(TournamentSidebar, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})